import { render, staticRenderFns } from "./RemoveAutoBid.vue?vue&type=template&id=0789d7c2&scoped=true&"
import script from "./RemoveAutoBid.vue?vue&type=script&lang=js&"
export * from "./RemoveAutoBid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0789d7c2",
  null
  
)

export default component.exports